<template>
  <div>
    <div class="row sections">
      <div
        v-for="section of sections"
        :key="section.ID"
        class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
      >
        <router-link
          :to="{ name: 'ArticlesSection', params: { 'id': section.ID }}"
          tag="div"
          class="img shadow-hover"
          :style="{ 'background-image': `url(${section.PICTURE_WIDE || section.PICTURE})` }"
        >
          <div class="title">
            <div
              class="name"
              v-text="section.NAME"
            />
            <div
              class="more"
            >
              Подробнее →
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <h2>Все статьи</h2>
    <publications
      type="articles"
      detail-route-name="ArticleDetail"
      more-text="Узнать больше"
    />
  </div>
</template>

<script>
import Publications from '../components/Publications'
import apiService from '../apiService'
import Notification from '../notification'

export default {
  name: 'Articles',
  components: { Publications },
  data () {
    return {
      sections: {}
    }
  },
  mounted () {
    this.fetchSections()
  },
  methods: {
    fetchSections () {
      apiService.getArticlesSections()
        .then(response => {
          this.sections = response.data.DATA
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список категорий.'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.sections {
  display: flex;
  flex-wrap: wrap;

  > div {
    padding: 15px;
    cursor: pointer;

    .img {
      width: 100%;
      height: 380px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      border-radius: 10px;

      &:after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 52%;
        z-index: 1;
        background: -webkit-gradient(linear,left top,left bottom,from(transparent),to(black));
        background: -webkit-linear-gradient(top,transparent 0%,black 100%);
        background: -o-linear-gradient(top,transparent 0%,black 100%);
        background: linear-gradient(to bottom,transparent 0%,black 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00000000",endColorstr="#e6000000",GradientType=0);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .title {
        position: absolute;
        left: 10px;
        right: 10px;
        bottom: 10px;
        z-index: 2;

        .name {
          color: white;
          font-weight: bold;
          font-size: 1.5em;
          text-decoration: none;
          z-index: 2;
          display: block;
        }

        .more {
          color: lightgray;
          font-size: 1.2em;
          text-decoration: none;
        }
      }
    }
  }
}

h2 {
  float: left;
}
</style>
